import { selectDealer } from '@packages/fdpq-core/actions/dealers';

export const mapStateToProps = state => state;
export const mapDispatchToProps = {
  onDealerSelected: selectDealer,
};
